(() => {
  const initCollection = (root = document) => {
    root.querySelectorAll('[data-ll-collection]').forEach((collectionRoot) => {
      if (collectionRoot.dataset.llReady === 'true') return;
      collectionRoot.dataset.llReady = 'true';

      collectionRoot.querySelectorAll('[data-ll-auto-submit="true"] [data-ll-filter-input]').forEach((input) => {
        input.addEventListener('change', () => input.form?.requestSubmit());
      });

      collectionRoot.querySelectorAll('[data-ll-sort-select]').forEach((select) => {
        select.addEventListener('change', () => select.form?.requestSubmit());
      });
    });

    root.querySelectorAll('[data-ll-filter-dialog]').forEach((dialog) => {
      if (dialog.dataset.llReady === 'true') return;
      dialog.dataset.llReady = 'true';

      const section = dialog.closest('.shopify-section');
      const openButton = section?.querySelector('[data-ll-filter-open]');
      const closeButton = dialog.querySelector('[data-ll-filter-close]');
      const applyButton = dialog.querySelector('[data-ll-filter-apply]');
      const form = dialog.querySelector('[data-ll-filter-form]');

      openButton?.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });

      closeButton?.addEventListener('click', () => dialog.close());
      applyButton?.addEventListener('click', () => form?.requestSubmit());

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => openButton?.focus());
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollection());
  } else {
    initCollection();
  }

  document.addEventListener('shopify:section:load', (event) => initCollection(event.target));
})();
